module.exports = __webpack_public_path__ + "img/eage1_1.0982dbfa.png";